import React from 'react'

const IcCheckGreen = ({ props }) => <svg {...props} width={15} height={16} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0)">
  <path d="M7.5 0.5C3.36433 0.5 0 3.86433 0 8C0 12.1357 3.36433 15.5 7.5 15.5C11.6357 15.5 15 12.1357 15 8C15 3.86433 11.6357 0.5 7.5 0.5Z" fill="white" />
  <path d="M11.3014 6.41061L7.23888 10.473C7.117 10.5949 6.95702 10.6563 6.79703 10.6563C6.63704 10.6563 6.47705 10.5949 6.35517 10.473L4.32396 8.44183C4.07951 8.19749 4.07951 7.80244 4.32396 7.55811C4.56829 7.31367 4.96323 7.31367 5.20767 7.55811L6.79703 9.14747L10.4177 5.5269C10.662 5.28246 11.057 5.28246 11.3014 5.5269C11.5458 5.77123 11.5458 6.16617 11.3014 6.41061Z" fill="#00B887" />
</g>
<defs>
  <clipPath id="clip0">
    <rect width={15} height={15} fill="white" transform="translate(0 0.5)" />
  </clipPath>
</defs>
</svg>

export default IcCheckGreen
